import { atom } from 'jotai'

export const initialValue: string =
  navigator.cookieEnabled && sessionStorage.getItem('givenName')

export const givenNameAtom = atom(initialValue)
